import "./purify.es-C_c8wluz.mjs";
const u = (n, t, r) => {
  if (n.length) {
    for (const e of n) {
      if (e.HstMenuItemRepresentation.url.includes(t) && e.HstMenuItemRepresentation.url.length - t.length === e.HstMenuItemRepresentation.url.indexOf(t))
        return {
          currentPage: e.HstMenuItemRepresentation.name,
          currentPageUrl: e.HstMenuItemRepresentation.url,
          currentPageParams: e.HstMenuItemRepresentation.parameters,
          breadCrumbs: r
        };
      if (e.HstMenuItemRepresentation.menuItems.length) {
        r.push({
          pageName: e.HstMenuItemRepresentation.name,
          pageURL: e.HstMenuItemRepresentation.url,
          pageParameters: e.HstMenuItemRepresentation.parameters
        });
        const s = u(
          e.HstMenuItemRepresentation.menuItems,
          t,
          r
        );
        if (s) return s;
      }
    }
    r.pop();
  }
}, m = (n) => {
  if (n.length) {
    const t = window.location.pathname;
    return u(n, t, []);
  }
};
export {
  m as g
};
//# sourceMappingURL=utils-1fgDetML.mjs.map
